var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMembershipOffers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 39 39"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "icon-membership-offers_svg__a",
  colorInterpolationFilters: "auto"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 1.000000 0 0 0 0 0.274510 0 0 0 0 0.176471 0 0 0 1.000000 0"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  filter: "url(#icon-membership-offers_svg__a)",
  transform: "translate(-11.853 -12)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#006FCF",
  fillRule: "nonzero",
  d: "M48.4 17.525a2.375 2.375 0 0 1 2.375 2.375v17.417a2.375 2.375 0 0 1-2.375 2.375h-2.375v3.958a2.375 2.375 0 0 1-2.375 2.375h-28.5a2.375 2.375 0 0 1-2.375-2.375V26.233a2.375 2.375 0 0 1 2.375-2.375h2.375V19.9a2.375 2.375 0 0 1 2.375-2.375zm-4.75 8.708h-28.5V43.65h28.5zM48.4 19.9H19.9v3.958h23.75a2.375 2.375 0 0 1 2.375 2.375v11.084H48.4zm-11.48 8.708c.657 0 1.188.532 1.188 1.188v1.979h1.98a1.188 1.188 0 0 1 0 2.375h-1.98v1.98a1.187 1.187 0 1 1-2.375 0v-1.98h-1.979a1.187 1.187 0 1 1 0-2.375h1.98v-1.98c0-.655.531-1.187 1.187-1.187z"
}))));
export default SvgIconMembershipOffers;